import React, {Component} from 'react';
import { NavBar, Session } from "../../components";
import {VIEW_NAME, config, SERVICE_API, DISPATCH_ID, SERVICE_RESPONSE, ROLES} from "../../libs/utils/Const";
import {connect} from 'react-redux';
import {ApiClient} from "../../libs/apiClient/ApiClient";
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';

let apiClient = ApiClient.getInstance();

class CartsSavedView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            CartSaveds : [],
            order: {
                header: {},
                body: []
            },
            fechaInicio: '',
            fechaFinal: '',
            fechaActual: '',
            checkboxDataTables: (new Map(): Map<string, boolean>),
        };
        this.table = null;
    };

    async componentDidMount(){
        let fechaInicio = moment(new Date()).format('YYYY-MM-DD');
        let fechaFinal = moment(new Date()).format('YYYY-MM-DD');
        this.setState({
            fechaInicio,
            fechaFinal
        });
        setTimeout(() => {
            this.cargarDatos();
        }, 2000);
    };

    async cargarDatos (){
        const {enableSpinner} = this.props;
        const {fechaInicio,fechaFinal} = this.state;
        enableSpinner(true);
        let seller = JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser'));
        let data ={
            usuario : seller.salesPrson,
            fechaInicio : fechaInicio,
            fechaFinal : fechaFinal
        }
        let newdatas = await apiClient.getCartSaveds(data);
        
        if (newdatas.status === SERVICE_RESPONSE.SUCCESS) {
            let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        
            user = JSON.parse(user) || {}; 
            
            this.setState({
                CartSaveds : newdatas.data.list,
                CardName : user.CardName,
                fechaActual : moment(new Date()).format('YYYY-MM-DD')
            });
    
            this.table = $('#CartsSaved').DataTable({
                "paging": false,
                "info": false,
                "searching": false
            });
            enableSpinner(false);
            return;
        }
        enableSpinner(false);
    };
    
    Details = async (valor, items, cardCode, shipAddress) => {
        const {notificationReducer: { showAlert }, enableSpinner} = this.props;
        
        enableSpinner(true);
        
        let data = {
            usuario : cardCode,
            Items : items
        }
        
        let responses = await apiClient.getDetailsCartSaveds(data);

        if (responses.data.list.length > 0 && responses.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: responses.data.list,
                U_Handel_Email: responses.data.datos[0].U_Handel_Email,
                U_Handel_Password : responses.data.datos[0].U_Handel_Password,
                shipAddress,
                idCarrito : valor,
            });

            $('#save').modal('show');
            enableSpinner(false);
            return;
        }
        else{
            this.setState({
                order: [],
            });
            showAlert({ type: 'error', message: 'Los artículos guardados en este carrito ya no son visibles para este cliente',timeOut: 5000 });
            enableSpinner(false);
            return;
        }
    }

    handleInputDateInicio = event =>{
        let fechaInicio = event.nativeEvent.target.value;
        this.setState({
            fechaInicio
        });
    }

    handleInputDateFinal = event =>{
        let fechaFinal = event.nativeEvent.target.value;
        this.setState({
            fechaFinal
        });
    }

    getData = async () =>{        
        this.table.destroy();
        this.cargarDatos();
    }

    CheckboxActions = async (docEntryArray, action = null) => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        
        docEntryArray.map(nuevo =>{
        })
        let responseArray = [];

        for (let document in docEntryArray) {
            enableSpinner(true);

            let statusAuthorization = "";
            let message = "";
            if (action == 1) {
                message = "Eliminando carrito de";
                statusAuthorization = 1;
            }
            let Documento = docEntryArray[document].CardName;
            showAlert({type: 'warning', message: message + ': ' + Documento, timeOut: 2500});

            let Id = docEntryArray[document].id;
            let response = "";

            if (action == 1) {
                response = await apiClient.deleteCartSaved(Id);
            }

            enableSpinner(false);
            try {
                responseArray.push({
                    docNum: Documento,
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    message: '',
                });
            }
        }
        return responseArray;
    };

    async addToShopingCart(){
        const {notificationReducer: {showAlert},configReducer,enableSpinner, setRememberUser,setUserSession,setRole,setToken} = this.props;
        const {order,U_Handel_Email,U_Handel_Password,shipAddress, idCarrito} = this.state;
        
        const orders = []; 

        for(var indice = 0; indice < order.length; indice++) {
            const arreglo = order[indice];
            let esDuplicado = false;
            for(var i = 0; i < orders.length; i++) {
                if (orders[i].ItemCode === arreglo.ItemCode) {
                    orders[i].Quantity += parseInt(arreglo.Quantity);
                    esDuplicado = true;
                    break;
                }
            }
            if (!esDuplicado) {
                orders.push(arreglo);
            }
        }

        let items = [];
        orders.map(item => {
            if(item.ItemCode !== "ENVIO"){
                items.push({ItemCode: item.ItemCode, quantity: parseInt(item.Quantity)});
            }
        });
        
        enableSpinner(true);

        // Agregar cliente 
        let user = {
            email: U_Handel_Email,
            password: U_Handel_Password,
        };

        let response = await apiClient.login(user,'');
        if(response.status === 0){
            return;
        }

        let vendedor = {
            salesPerson: "0",
            firstName: "Vendedor",
            lastName: "Desde cliente"
        };
        
        enableSpinner(true);
        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            let user = response.data.user;
            let token = response.data.token;
            let remember = true;
            
            localStorage.setItem(config.general.localStorageNamed + 'Token', JSON.stringify(token));
            localStorage.setItem(config.general.localStorageNamed + 'Role', ROLES.CLIENT);
            localStorage.setItem(config.general.localStorageNamed + 'CurrentUser', JSON.stringify(user));
            localStorage.setItem(config.general.localStorageNamed + 'Vendor', JSON.stringify(vendedor));
            localStorage.setItem(config.general.localStorageNamed + 'RememberUser', remember );
            localStorage.setItem(config.general.localStorageNamed + 'ShipAddress', shipAddress );

            setRole(ROLES.CLIENT);
            setToken(token);
            setUserSession(user);
            setRememberUser(remember);

            let responsesd = await apiClient.updateShoppingCartLocal(items);

            localStorage.removeItem(config.general.localStorageNamed + 'shoppingCart');

            enableSpinner(false);
            setTimeout(async ()=> {
                if(responsesd.data.value > 0){
                    $('#save').modal('hide');
                    await apiClient.deleteCartSaved(idCarrito);
                    showAlert({type: 'success', message: ' Agregado a carrito correctamente ', timeOut: 0});
                    configReducer.history.goShoppingCart();
                }else{
                    configReducer.history.goHome();
                }
            },50);
            
            return;
        }
        // Agregar cliente
        enableSpinner(false);
    }

    DeleteMasive = async response => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        const {CartSaveds, checkboxDataTables} = this.state;
        let docEntryArray = [];
        let responseArray = [];
        for (let [id, value] of checkboxDataTables.entries()) {
            if (value) {
                docEntryArray.push(CartSaveds[id]);
            }
        }
        if(docEntryArray.length>0){
            responseArray = await this.CheckboxActions(docEntryArray,1);
            this.toggleDocumentSelectedAll(false);
            
            this.setState({
                checkboxDataTables: (new Map(): Map<string, boolean>),
                responseArray 
            })
            this.table.destroy();
            this.cargarDatos();

        } else{
            showAlert({type: 'error', timeOut: 2000, message: "Seleccione un carrito"});
            return;
        }
    };

    toggleDocumentSelected = (id) => {
        this.setState(state => {
            const checkboxDataTables = new Map(state.checkboxDataTables);
            checkboxDataTables.set(id, !checkboxDataTables.get(id)); // toggle
            return {checkboxDataTables};
        });
    };

    toggleDocumentSelectedAll = (action) => {
        const {CartSaveds} = this.state;
        let newCheckbox = (new Map(): Map<string, boolean>);
        CartSaveds.map((register, index) => {
            newCheckbox.set(index, action)
        });
        this.setState({
            checkboxDataTables: newCheckbox
        });
    };

    render() {
        const {history} = this.props;
        const {CartSaveds, order, fechaInicio, fechaFinal, fechaActual, checkboxDataTables} = this.state; 
        
        let checkbox = {
            data: checkboxDataTables,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        return (
            <div className="content-fluid marginTable" style={{marginTop: 66}}>
                <Session history={history} view={VIEW_NAME.PROMO_VIEW}/>
                <NavBar/>

                <div className="container mb-4" style={{paddingTop: 60}}>
                    <div className="row">
                        <div className="col">
                            <div className="jumbotron" style={{paddingTop:'10px', paddingBottom:'10px'}}>
                                <h1 className="display-6 text-center">Lista de carritos guardados</h1>
                            </div>
                        </div>    
                    </div>
                    <br></br>
                    <div className="row text-center" style={{marginBottom: 16, marginTop: 16}}>
                        <div className=" row col-md-4">
                            <h4 className="pr-2">Desde:</h4>
                            <input 
                                id="fechaInicio"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechauno" 
                                max={fechaActual}
                                value = {fechaInicio}
                                onChange = {(event) => this.handleInputDateInicio(event)}/>
                        </div>
                        <div className="row col-md-4 pb-3">
                            <h4 className="pr-2">Hasta:</h4>
                            <input 
                                id="FechaFin"
                                type="date" 
                                className="form-control col-md-6" 
                                name="fechados" 
                                max={fechaActual}
                                value = {fechaFinal}
                                onChange = {(event) => this.handleInputDateFinal(event)}/>
                        </div>
                        <div className="col-md-2 pb-2">
                            <button
                                onClick={()=>this.getData()}
                                className="btn botonResumen" 
                                style={{
                                    backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                    color: config.navBar.textColorCategorieHover,
                                    fontWeight: "bold",
                                }}>
                                Ver pedidos
                            </button>
                        </div>
                    </div> 
                    <button type="button" class="btn btn-danger float-right" onClick={()=>this.DeleteMasive()}>Eliminar carritos</button>
                    <div className="table-responsive" style={{marginBottom: 0, height: 400, maxHeight: 400, overflow: 'auto'}}> 
                        <table id="CartsSaved" className="table table-hover scrolltable" style={{marginRight: 0, marginLeft: 0}}>
                            <thead >
                                <tr className="text-light text-center" style={{background: '#2d75bd', borderRadius: '0'}} >
                                <th scope="col">#</th>
                                <th className="sticky-column" >
                                    <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" value="second_checkbox"
                                        onChange={(event) => checkbox.selectAll(event.target.checked)}/>
                                </th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Código cliente</th>
                                <th scope="col">Cliente</th>
                                <th scope="col">Zona</th>
                                <th scope="col">Dirección de envío</th>
                                <th scope="col">Peso neto</th>
                                <th scope="col">Valor</th>
                                <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {!!CartSaveds && CartSaveds.map((cart, index ) => {
                                    return(
                                        <tr className="text-center" >
                                            <th scope="row">{index+1}</th>
                                            <td className="text-center">
                                                <input type="checkbox" style={{minWidth: '100%'}} id="cbox2"
                                                    checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)}/>
                                            </td>
                                            <td>{cart.DateCart}</td>
                                            <td>{cart.CardCode}</td>
                                            <td>{cart.CardName}</td>
                                            <td>{cart.Zona}</td>
                                            <td>{cart.DirEnvio}</td>
                                            <td>{ parseFloat(cart.PesoNeto > 0 ? cart.PesoNeto : 0).toFixed(2) + ' KG' }</td>
                                            <td>
                                                <CurrencyFormat
                                                    value={cart.Valor > 0 ? cart.Valor : 0}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    fixedDecimalScale={true}
                                                    decimalScale={2}
                                                    prefix={config.general.currency}>
                                                </CurrencyFormat>
                                            </td>
                                            <td>
                                                <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    style={{ backgroundColor: config.navBar.iconBackground, color: config.navBar.iconModal }}
                                                    onClick={() => this.Details(cart.id, cart.Cart, cart.CardCode, cart.DirEnvio)}> 
                                                   Visualizar
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    
                </div> 

                <div class="modal fade bd-example-modal-xl" id="save" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header text-light" style={{background: '#2d75bd', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Detalle de carrito</h4>

                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body bg3">
                                {order && order.length > 0 && order.map(item => {
                                    return <div key={item.ItemCode} className="row">
                                        <div className="col-md-3 text-center">
                                            <img className="img-fluid" style={{ backgroundColor: 'white', maxHeight: 130 }}
                                                src={item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../../images/noImage.png')}
                                                alt=""
                                            />
                                        </div>
                                        <div className="col-md-8 table-responsive">
                                            <div className="container p-0">
                                                <div className="row text-left">
                                                    <div className="col-md-12"  style={{borderBottom: '1px solid rgb(124, 124, 125)'}}>
                                                        {item.ItemName}
                                                    </div>
                                                </div>
                                                <div className="row font-weight-bold ">
                                                    <div className="col-md-3 text-center">
                                                        Código
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Cantidad
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Precio unitario
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        Precio total
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 text-center">
                                                        {item.ItemCode}
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        {parseInt(item.Quantity)}
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        <CurrencyFormat
                                                            value={Number(item.Price) + Number((item.Price * (18 / 100)))}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={2}
                                                            prefix={config.general.currency}>
                                                        </CurrencyFormat>                                                        
                                                    </div>
                                                    <div className="col-md-3 text-center">
                                                        <CurrencyFormat
                                                            value={(Number(item.Price) + Number((item.Price * (18 / 100)))) * parseInt(item.Quantity)}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            fixedDecimalScale={true}
                                                            decimalScale={2}
                                                            prefix={config.general.currency}>
                                                        </CurrencyFormat>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                })}
                                
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                                <button type="button" className="btn btn-success" onClick={()=> this.addToShopingCart()}>
                                    <i className="fas fa-cart-plus"/>
                                    &nbsp; Agregar al carrito
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setRememberUser: value =>  dispatch({type: DISPATCH_ID.SESSION_SET_REMEMBER_USER, value}),
        setUserSession: value => dispatch({type: DISPATCH_ID.SESSION_SET_USER, value}),
        setRole: value => dispatch({type: DISPATCH_ID.SESSION_SET_ROLE, value}),
        setToken: value => dispatch({type: DISPATCH_ID.SESSION_SET_TOKEN, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartsSavedView);

